<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="query_con">
      <h2 class="exam_con_t">确认个人信息</h2>
      <table cellspacing="0" border="1" class="kaoshi_table">
        <tr>
          <td class="query_pL">姓名：</td>
          <td class="query_pR">{{ userInfo.userName }}</td>
        </tr>
        <tr>
          <td class="query_pL">学号：</td>
          <td class="query_pR">{{ userInfo.studentNo }}</td>
        </tr>
        <tr>
          <td class="query_pL">准考证号：</td>
          <td class="query_pR">{{ userInfo.certNo }}</td>
        </tr>
        <tr>
          <td class="query_pL">身份证号码：</td>
          <td class="query_pR">{{ userInfo.idCardNo }}</td>
        </tr>
        <tr>
          <td class="query_pL">证件照片：</td>
          <td class="query_pR"><img :src="userInfo.faceUrl" style="width:240px;height:240px" /></td>
        </tr>
      </table>

      <a href="javascript:void(0);" @click="nextStep()" class="query_btn"
        >确认，下一步</a
      >
    </div>
  </div>
</template>

<script>
import { getExamById, myInfo, createH5FaceOrder, logout } from "@/api/login";
export default {
  name: "ConfirmProfile",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: ""
      },
      userInfo: {},
      testInfo: {},
      examUserId: "",
      uploadUrl: process.env.VUE_APP_RETURN_URL
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;
    this.initData();
  },
  methods: {
    initData() {
      myInfo(this.examBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
          return;
        }
      });
      getExamById(this.tokenBean).then(res => {
        if (res.code === 200) {
          this.testInfo = res.data;
        }
      });
    },
    nextStep() {
      // 不需要人脸识别，或者特例学生不需要人脸识别
      if (this.testInfo.loginDetect === 1 || this.userInfo.specialFlag === 1) {
        // 过程需要监控并且不是特例学生
        if (this.testInfo.detectInprocess === 2 && this.userInfo.specialFlag === 0) {
          this.$router.push({
            path: "/checkVideo",
            query: { examUserId: this.examUserId }
          });
        } else {
          this.$router.push({
            path: "/examCatalog",
            query: { examUserId: this.examUserId }
          });
        }
        return;
      }
      if (this.userInfo.faceStatus != 3) {
        alert("考生还没有头像相片，先进行头像相片采集");
        this.$router.push("/profile");
        return;
      }
      createH5FaceOrder(this.tokenBean).then(res => {
        console.log(res.data);
        const callBackUrl = encodeURIComponent(
          this.uploadUrl + this.examUserId
        );
        this.redirectUrl =
          "https://ida.webank.com/api/pc/login?webankAppId=" +
          res.data.config.wbappid +
          "&version=" +
          res.data.config.version +
          "&nonce=" +
          res.data.config.nonce +
          "&orderNo=" +
          res.data.result.data.orderNo +
          "&h5faceId=" +
          res.data.result.data.faceId +
          "&url=" +
          callBackUrl +
          "&userId=" +
          res.data.result.data.userId +
          "&sign=" +
          res.data.result.data.sign;
        console.log(this.redirectUrl);
        window.location.href = this.redirectUrl;
      });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.tokenBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.tokenBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        console.log(this.examBean);
        logout(this.examBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
          }
        });
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style scoped></style>